<template>
  <div class="stopwatch">
    {{chrono}}
  </div>
</template>

<script>
import 'core-js/fn/string/pad-start';

export default {
  data() {
    return {
      time: null,
      centiseconds: 0,
      seconds: 0,
      minutes: 0
    };
  },

  created() {
    this.running = false;
  },
  destroyed() {
    this.running = false;
    this.time = null;
  },
  computed: {
    chrono() {
      const [mins, secs, sc] = [
        this.minutes, this.seconds, Math.floor(this.centiseconds)
      ].map(t => `${t}`.padStart(2, '0'));

      return `${mins}:${secs}:${sc}`;
    }
  },
  methods: {
    start() {
      if(!this.time) {
        this.time = performance.now();
      }
      if(!this.running) {
        this.running = true;
        requestAnimationFrame(this.step);
      }
    },

    stop() {
      this.running = false;
    },

    step(timestamp) {
      if(!this.running) {
        return;
      }
      this.calculate(timestamp);
      this.time = timestamp;
      requestAnimationFrame(this.step);
    },

    calculate(timestamp) {
      const diff = timestamp - this.time;

      // Hundredths of a second are 100 ms
      this.centiseconds += diff / 10;

      // Seconds are 100 hundredths of a second
      if(this.centiseconds >= 100) {
        this.seconds += 1;
        this.centiseconds -= 100;
      }
      // Minutes are 60 seconds
      if(this.seconds >= 60) {
        this.minutes += 1;
        this.seconds -= 60;
      }
    },

    toTimestamp() {
      return (this.minutes * 60) + this.seconds + (this.centiseconds / 100);
    }
  }
};
</script>

<style lang="less" scoped>
@import (reference) "../styles/variables.less";
</style>



// WEBPACK FOOTER //
// src/components/StopWatch.vue